import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';
import { AlertTriangle, Coins, FileScan, HardDrive, Workflow, Zap, ArrowRight } from 'lucide-react';
import { brandColors } from './Brand';

// Maps a backend 402 error code to the modal copy + the Billing section to focus.
const QUOTA_MAP = {
  storage_limit_exceeded: { title: 'Storage limit reached', cta: 'Upgrade Plan', focus: 'plans', Icon: HardDrive },
  insufficient_ai_credits: { title: 'Out of AI Credits', cta: 'Buy AI Credits', focus: 'credits', Icon: Coins },
  insufficient_ocr_pages: { title: 'Out of OCR Pages', cta: 'Buy OCR Pages', focus: 'ocr', Icon: FileScan },
  workflow_limit_exceeded: { title: 'Workflow limit reached', cta: 'Upgrade Plan', focus: 'plans', Icon: Workflow },
  api_limit_exceeded: { title: 'Monthly API limit reached', cta: 'Upgrade Plan', focus: 'plans', Icon: Zap },
};

export const QuotaExceededModal = () => {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      const detail = e.detail || {};
      if (detail && detail.error && QUOTA_MAP[detail.error]) {
        setInfo(detail);
        setOpen(true);
      }
    };
    window.addEventListener('quota:exceeded', handler);
    return () => window.removeEventListener('quota:exceeded', handler);
  }, []);

  const cfg = QUOTA_MAP[info.error] || { title: 'Limit reached', cta: 'View Billing', focus: 'plans', Icon: AlertTriangle };
  const Icon = cfg.Icon;

  const goBilling = () => {
    setOpen(false);
    navigate(`/billing?focus=${cfg.focus}`);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="quota-exceeded-modal" className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-amber-100">
              <Icon className="h-5 w-5 text-amber-600" />
            </div>
            <DialogTitle data-testid="quota-modal-title" className="text-lg">{cfg.title}</DialogTitle>
          </div>
          <DialogDescription data-testid="quota-modal-message" className="pt-3 text-slate-600">
            {info.message || 'You have reached a plan limit. Upgrade your plan or top up to continue.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={() => setOpen(false)} data-testid="quota-modal-dismiss">
            Not now
          </Button>
          <Button onClick={goBilling} data-testid="quota-modal-upgrade"
            style={{ backgroundColor: brandColors.primary }}>
            {cfg.cta} <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default QuotaExceededModal;
